export default function CPointers() {
  return <h2>C Pointers</h2>;
}
